if (!customElements.get('banner-slider')) {
  class BannerSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll(':scope > .banner__media'));
      if (this.slides.length < 2) return;

      this.index = Math.max(
        0,
        this.slides.findIndex((slide) => slide.classList.contains('is-active'))
      );
      this.interval = Number(this.dataset.interval || 5000);
      this.running = false;
      this.boundAdvance = this.next.bind(this);

      this.slides.forEach((slide) => this.prepareVideo(slide, false));

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.start();
            else this.stop();
          });
        },
        { threshold: 0.2 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.stop();
      this.observer?.disconnect();
    }

    prepareVideo(slide, shouldPlay) {
      const video = slide.querySelector('video');
      if (!video) return;

      video.muted = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.loop = false;
      video.removeAttribute('loop');

      if (shouldPlay) {
        try {
          video.currentTime = 0;
        } catch (error) {}
        video.play().catch(() => {});
      } else {
        video.pause();
        try {
          video.currentTime = 0;
        } catch (error) {}
      }
    }

    start() {
      if (this.running) return;
      this.running = true;
      this.prepareVideo(this.slides[this.index], true);
      this.scheduleAdvance();
    }

    stop() {
      this.running = false;
      this.clearTimer();
      this.slides.forEach((slide) => this.prepareVideo(slide, false));
    }

    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.slides.forEach((slide) => {
        const video = slide.querySelector('video');
        if (video) video.removeEventListener('ended', this.boundAdvance);
      });
    }

    scheduleAdvance() {
      this.clearTimer();
      const video = this.slides[this.index].querySelector('video');

      if (video) {
        video.addEventListener('ended', this.boundAdvance, { once: true });
        const durationMs =
          video.duration > 0 && Number.isFinite(video.duration) ? video.duration * 1000 : this.interval;
        this.timer = setTimeout(this.boundAdvance, durationMs + 80);

        if (!(video.duration > 0)) {
          video.addEventListener(
            'loadedmetadata',
            () => {
              if (!this.running) return;
              this.scheduleAdvance();
            },
            { once: true }
          );
        }
        return;
      }

      this.timer = setTimeout(this.boundAdvance, this.interval);
    }

    next() {
      if (!this.running) return;
      this.clearTimer();

      const previous = this.slides[this.index];
      this.index = (this.index + 1) % this.slides.length;
      const current = this.slides[this.index];

      previous.classList.remove('is-active');
      current.classList.add('is-active');
      this.prepareVideo(previous, false);
      this.prepareVideo(current, true);
      this.scheduleAdvance();
    }
  }

  customElements.define('banner-slider', BannerSlider);
}
